import PrivateRoute from '../../components/PrivateRoute';
import { NotificationsProvider } from '../../contexts/NotificationsContext';
import CentralNotificacaoList from './CentralNotificacaoList';

export function CentralNotificacaoRoutes(permissao: number): JSX.Element {
    return (
        <>
            <NotificationsProvider>
            <PrivateRoute path={permissao != 4 ? "/central-notificacoes" : ''} element={< CentralNotificacaoList />} />
            </NotificationsProvider>
        </>
    );
}
